import Configuration from '@/utils/configuration';

const ASSETS_HOST = Configuration.value('VUE_APP_ASSETS_HOST');

const courseData = {
  courses: [
    {
      name: 'Quarry Ridge Golf Course',
      key: 'qr',
      courseID: '018ef01e-8d79-4fef-9532-3b45e2fbf6a6',
      host: ASSETS_HOST,
      logo: '',
    },
  ],
};

export { courseData };
